module.exports = __webpack_public_path__ + "static/media/pbintBlackText.f5dd1d3f.png";